import {
  ADD_CATEGORY_PATH,
  ADD_LEGAL_ENTITY_PATH,
  ADD_PAYMENT_ACCOUNT_PATH,
  ADD_POSITION_PATH,
  ADD_SERVICE_PATH,
  EDIT_CATEGORY_PATH,
  EDIT_PAYMENT_ACCOUNT_PATH,
  EDIT_POSITION_PATH,
  EDIT_SERVICE_PATH,
  PROFILE_PATH,
} from '@app/constants/navigation';

export const PATHS_WITH_POTENTIAL_UNSAVED_DATA = [
  ADD_POSITION_PATH,
  EDIT_POSITION_PATH,
  ADD_LEGAL_ENTITY_PATH,
  '/legalEntities/edit/',
  EDIT_CATEGORY_PATH,
  ADD_CATEGORY_PATH,
  ADD_PAYMENT_ACCOUNT_PATH,
  EDIT_PAYMENT_ACCOUNT_PATH,
  '/clients/edit/',
  '/clients/add',
  '/users/add',
  '/users/edit/',
  '/employees/add/',
  '/chains/add/',
  '/chains/edit/',
  ADD_SERVICE_PATH,
  EDIT_SERVICE_PATH,
  '/branches/add',
  '/branches/edit/',
  PROFILE_PATH,
];
